import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Avatar,
  Menu,
  MenuItem as MenuItemComponent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import {
  NotificationsOutlined,
  Add,
  Close,
  Edit,
  Delete
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { apiService } from '../services/api';
import logo from '../assets/logo.png';
import AdminServicesPage from './AdminServicesPage';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [, setUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [projects, setProjects] = useState([]);
  const [staff, setStaff] = useState([]);
  const [schemes, setSchemes] = useState([]);

  const [openStaffDialog, setOpenStaffDialog] = useState(false);
  const [openSchemeDialog, setOpenSchemeDialog] = useState(false);
  const [openSchemeDetailDialog, setOpenSchemeDetailDialog] = useState(false);
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [editingScheme, setEditingScheme] = useState(null);




  const [openAssignDialog, setOpenAssignDialog] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [editingStaff, setEditingStaff] = useState(null);
  const [deleteStaffDialog, setDeleteStaffDialog] = useState(false);
  const [staffToDelete, setStaffToDelete] = useState(null);
  const [selectedConsultant, setSelectedConsultant] = useState(null);
  const [openConsultantDialog, setOpenConsultantDialog] = useState(false);
  const [selectedEntrepreneur, setSelectedEntrepreneur] = useState(null);
  const [openEntrepreneurDialog, setOpenEntrepreneurDialog] = useState(false);
  const [entrepreneurProjects, setEntrepreneurProjects] = useState([]);
  const [openAdminProfileDialog, setOpenAdminProfileDialog] = useState(false);
  const [adminProfileData, setAdminProfileData] = useState({
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    phone: '',
    current_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [documentViewerOpen, setDocumentViewerOpen] = useState(false);
  const [viewingDocument, setViewingDocument] = useState(null);
  const [staffData, setStaffData] = useState({
    name: '',
    email: '',
    phone: '',
    specialization: '',
    designation: '',
    password: '',
    assignedProjects: []
  });
  const [schemeData, setSchemeData] = useState({
    title: '',
    description: '',
    eligibility: '',
    benefits: '',
    deadline: '',
    region: '',
    subsidy_amount: '',
    policy_validity: '',
    category: 'msme'
  });


  const [totalUsers, setTotalUsers] = useState(0);
  const [totalProjects, setTotalProjects] = useState(0);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [consultantFilter, setConsultantFilter] = useState('');
  const [bulkAction, setBulkAction] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const userInfo = localStorage.getItem('userInfo');
    
    if (!token) {
      navigate('/login');
      return;
    }
    
    if (userInfo) {
      const userData = JSON.parse(userInfo);
      if (!userData.is_superuser) {
        navigate('/dashboard');
        return;
      }
      setUser(userData);
    }

    // Load data
    loadProjectsPage();
    loadStaff();
    loadSchemes();

    loadUsers();

    // Load data once on mount
    return () => {}; // No cleanup needed
  }, [navigate]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [consultantsPage, setConsultantsPage] = useState(1);
  const [consultantsTotalPages, setConsultantsTotalPages] = useState(1);
  const [consultantsTotalCount, setConsultantsTotalCount] = useState(0);
  const [selectedProject, setSelectedProject] = useState(null);
  const [openProjectDialog, setOpenProjectDialog] = useState(false);

  const loadUsers = async (page = 1) => {
    try {
      const response = await apiService.getUsers();
      const data = response.data;
      const allUsers = data.results || data || [];
      // Filter to show only regular users (not staff or admin)
      const entrepreneursOnly = allUsers.filter(user => !user.is_staff && !user.is_superuser);
      setUsers(entrepreneursOnly);
      setTotalUsers(entrepreneursOnly.length);
      setTotalCount(data.count || entrepreneursOnly.length);
      setTotalPages(Math.ceil((data.count || entrepreneursOnly.length) / 10));
      setCurrentPage(page);
    } catch (error) {
      console.error('Error loading users:', error);
      setUsers([]);
      setTotalUsers(0);
    }
  };



  // Remove auto-refresh to stop unnecessary API calls

  const loadStaff = async (page = 1) => {
    try {
      const response = await apiService.getStaff(page);
      const data = response.data;
      const allStaff = data.results || data || [];
      // Filter out admin/superuser accounts - only show consultants/staff
      const consultantsOnly = allStaff.filter(member => !member.is_superuser);
      setStaff(consultantsOnly);
      setConsultantsTotalCount(consultantsOnly.length);
      setConsultantsTotalPages(Math.ceil(consultantsOnly.length / 10));
      setConsultantsPage(page);
    } catch (error) {
      console.error('Error loading staff:', error);
      setStaff([]);
    }
  };

  const loadSchemes = async () => {
    try {
      const response = await apiService.getAdminSchemes();
      const schemesData = response.data.results || response.data || [];
      setSchemes(schemesData);
    } catch (error) {
      console.error('Error loading schemes:', error);
      setSchemes([]);
    }
  };

  const handleToggleSchemeStatus = async (schemeId) => {
    try {
      await apiService.toggleSchemeStatus(schemeId);
      await loadSchemes();
    } catch (error) {
      console.error('Error toggling scheme status:', error);
      alert('Failed to update scheme status. Please try again.');
    }
  };

  const loadEntrepreneurProjects = async (userId) => {
    try {
      const response = await apiService.getUserProjects(userId);
      const projectsData = response.data.results || response.data || [];
      setEntrepreneurProjects(projectsData);
    } catch (error) {
      console.error('Error loading entrepreneur projects:', error);
      setEntrepreneurProjects([]);
    }
  };

  const generateServiceId = (serviceName, userId) => {
    const servicePrefix = {
      'gst_registration': 'GST-AP',
      'udyam_registration': 'UDYAM-AP', 
      'firm_registration': 'FIRM-AP',
      'others': 'SRV-AP'
    };
    const prefix = servicePrefix[serviceName] || 'SRV-AP';
    const randomNum = Math.floor(10000000 + Math.random() * 90000000);
    return `${prefix}-${userId}-${randomNum}`;
  };

  const getServiceDisplayName = (serviceKey) => {
    const serviceNames = {
      'gst_registration': 'GST Registration',
      'udyam_registration': 'UDYAM Registration',
      'firm_registration': 'Firm Registration',
      'others': 'Other Services'
    };
    return serviceNames[serviceKey] || serviceKey;
  };



  const handleLogout = async () => {
    try {
      await authService.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      navigate('/login');
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };





  const handleAddStaff = async () => {
    try {
      const nameParts = staffData.name.split(' ');
      const staffPayload = {
        email: staffData.email,
        first_name: nameParts[0] || '',
        last_name: nameParts.slice(1).join(' ') || '',
        phone: staffData.phone,
        specialization: staffData.specialization,
        designation: staffData.designation,
        is_staff: true,
        is_active: true
      };

      // Only include username for new staff
      if (!editingStaff) {
        staffPayload.username = staffData.name.toLowerCase().replace(/\s+/g, '_');
      }

      // Only include password if provided and not empty
      if (staffData.password && staffData.password.trim() !== '') {
        staffPayload.password = staffData.password.trim();
        console.log('Password will be updated');
      }

      // Include assigned projects in the payload
      if (staffData.assignedProjects && staffData.assignedProjects.length > 0) {
        staffPayload.assigned_projects = staffData.assignedProjects;
      }

      if (editingStaff) {
        // Update staff details with assigned projects
        await apiService.updateStaff(editingStaff.id, staffPayload);
        await loadProjectsPage(); // Reload projects to reflect consultant assignments
        setEditingStaff(null);
      } else {
        await apiService.createStaff(staffPayload);
      }
      
      await loadStaff();
      await loadProjectsPage(); // Reload projects to reflect consultant assignments
      setOpenStaffDialog(false);
      setStaffData({ name: '', email: '', phone: '', specialization: '', designation: '', password: '', assignedProjects: [] });
    } catch (error) {
      console.error('Error saving staff:', error);
      alert('Failed to save staff member. Please try again.');
    }
  };

  const handleEditStaff = (member) => {
    setEditingStaff(member);
    setStaffData({
      name: member.first_name && member.last_name ? `${member.first_name} ${member.last_name}` : member.username,
      email: member.email,
      phone: member.phone || member.profile?.phone || '',
      specialization: member.specialization || member.profile?.specialization || '',
      designation: member.designation || member.profile?.designation || 'Consultant',
      password: '',
      assignedProjects: member.assigned_projects || member.assignedProjects || []
    });
    setOpenStaffDialog(true);
  };

  const handleDeleteStaff = (member) => {
    setStaffToDelete(member);
    setDeleteStaffDialog(true);
  };

  const confirmDeleteStaff = async () => {
    if (staffToDelete) {
      try {
        await apiService.deleteStaff(staffToDelete.id);
        await loadStaff();
        setDeleteStaffDialog(false);
        setStaffToDelete(null);
      } catch (error) {
        console.error('Error deleting staff:', error);
        alert('Failed to delete staff member. Please try again.');
      }
    }
  };



  const handleAssignProjects = (staffId, projectIds) => {
    const updatedStaff = staff.map(member => 
      member.id === staffId 
        ? { ...member, assignedProjects: projectIds, assignedProjectsCount: projectIds.length }
        : member
    );
    setStaff(updatedStaff);
    localStorage.setItem('staffMembers', JSON.stringify(updatedStaff));
  };

  const handleAddScheme = async () => {
    try {
      const schemePayload = {
        title: schemeData.title,
        description: schemeData.description,
        eligibility: schemeData.eligibility,
        benefits: schemeData.benefits,
        deadline: schemeData.deadline,
        region: schemeData.region,
        subsidy_amount: schemeData.subsidy_amount,
        policy_validity: schemeData.policy_validity,
        status: 'active',
        category: schemeData.category
      };
      
      if (editingScheme) {
        await apiService.updateScheme(editingScheme.id, schemePayload);
        setEditingScheme(null);
      } else {
        await apiService.createScheme(schemePayload);
      }
      
      await loadSchemes();
      setOpenSchemeDialog(false);
      setSchemeData({ title: '', description: '', eligibility: '', benefits: '', deadline: '', region: '', subsidy_amount: '', policy_validity: '', category: 'msme' });
    } catch (error) {
      console.error('Error saving scheme:', error);
      alert('Failed to save scheme. Please try again.');
    }
  };

  const handleEditScheme = (scheme) => {
    setEditingScheme(scheme);
    setSchemeData({
      title: scheme.title,
      description: scheme.description,
      eligibility: scheme.eligibility,
      benefits: scheme.benefits,
      deadline: scheme.deadline,
      region: scheme.region || '',
      subsidy_amount: scheme.subsidy_amount || '',
      policy_validity: scheme.policy_validity || '',
      category: scheme.category || 'msme'
    });
    setOpenSchemeDialog(true);
  };

  const handleDeleteScheme = async (scheme) => {
    if (window.confirm(`Are you sure you want to delete "${scheme.title}"?`)) {
      try {
        await apiService.deleteScheme(scheme.id);
        await loadSchemes();
      } catch (error) {
        console.error('Error deleting scheme:', error);
        alert('Failed to delete scheme. Please try again.');
      }
    }
  };



  const renderNewDashboard = () => (
    <Box>
      {/* Stats Cards Row */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ p: 3, textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <Typography sx={{ fontSize: '32px', mb: 1 }}>👥</Typography>
            <Typography variant="h3" sx={{ fontWeight: 700, color: '#1e293b', mb: 1 }}>{totalUsers}</Typography>
            <Typography color="text.secondary" sx={{ fontWeight: 500 }}>Total Entrepreneurs</Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ p: 3, textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <Typography sx={{ fontSize: '32px', mb: 1 }}>📊</Typography>
            <Typography variant="h3" sx={{ fontWeight: 700, color: '#1e293b', mb: 1 }}>{totalProjects || projects.length}</Typography>
            <Typography color="text.secondary" sx={{ fontWeight: 500 }}>Total Projects</Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ p: 3, textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <Typography sx={{ fontSize: '32px', mb: 1 }}>🔗</Typography>
            <Typography variant="h3" sx={{ fontWeight: 700, color: '#1e293b', mb: 1 }}>{staff.length}</Typography>
            <Typography color="text.secondary" sx={{ fontWeight: 500 }}>Total Consultants</Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ p: 3, textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <Typography sx={{ fontSize: '32px', mb: 1 }}>📋</Typography>
            <Typography variant="h3" sx={{ fontWeight: 700, color: '#1e293b', mb: 1 }}>{schemes.length}</Typography>
            <Typography color="text.secondary" sx={{ fontWeight: 500 }}>Total Schemes</Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ p: 3, textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <Typography sx={{ fontSize: '32px', mb: 1 }}>📄</Typography>
            <Typography variant="h3" sx={{ fontWeight: 700, color: '#1e293b', mb: 1 }}>96</Typography>
            <Typography color="text.secondary" sx={{ fontWeight: 500 }}>Total DPRs</Typography>
          </Card>
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        {/* Left Column */}
        <Grid item xs={12} md={8}>
          {/* Pending Items Row */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} sm={6}>
              <Card sx={{ p: 3, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Typography sx={{ fontSize: '20px', mr: 2 }}>⚠️</Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>Pending KYC</Typography>
                </Box>
                <Typography color="text.secondary">5 Entrepreneurs</Typography>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Card sx={{ p: 3, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Typography sx={{ fontSize: '20px', mr: 2 }}>ℹ️</Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>Pending Document Verifications</Typography>
                </Box>
                <Typography color="text.secondary">3 Entrepreneurs</Typography>
              </Card>
            </Grid>
          </Grid>

          {/* Active Schemes Section */}
          <Card sx={{ p: 3, mb: 4, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>Active Schemes</Typography>
              <Typography 
                sx={{ color: '#3b82f6', cursor: 'pointer', fontWeight: 500 }}
                onClick={() => setActiveTab(4)}
              >
                Manage Schemes ›
              </Typography>
            </Box>
            <Grid container spacing={3}>
              {schemes.slice(0, 4).map((scheme, index) => (
                <Grid item xs={12} sm={6} key={scheme.id || index}>
                  <Box sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>{scheme.title}</Typography>
                    <Typography color="text.secondary" variant="body2">{scheme.status === 'active' ? 'Active' : 'Inactive'}</Typography>
                  </Box>
                </Grid>
              ))}
              {schemes.length === 0 && (
                <Grid item xs={12}>
                  <Typography color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>No schemes available</Typography>
                </Grid>
              )}
            </Grid>
          </Card>


        </Grid>

        {/* Right Column - Action Buttons */}
        <Grid item xs={12} md={4}>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 3 }}>
            <Card 
              sx={{ p: 4, textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', cursor: 'pointer', flex: 1 }}
              onClick={() => setOpenSchemeDialog(true)}
            >
              <Typography sx={{ fontSize: '48px', mb: 2 }}>📢</Typography>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>Create Scheme</Typography>
            </Card>
            <Card 
              sx={{ p: 4, textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', cursor: 'pointer', flex: 1 }}
              onClick={() => setActiveTab(2)}
            >
              <Typography sx={{ fontSize: '48px', mb: 2 }}>👥</Typography>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>Manage Users</Typography>
            </Card>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );

  const renderEntrepreneurs = () => {
    if (!users || users.length === 0) {
      return (
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>Entrepreneurs Management</Typography>
          <Typography>No registered users found.</Typography>
        </Box>
      );
    }

    const filteredUsers = users.filter(user => {
      if (!user) return false;
      const name = user.name || user.username || '';
      const email = user.email || '';
      return name.toLowerCase().includes(searchTerm.toLowerCase()) ||
             email.toLowerCase().includes(searchTerm.toLowerCase());
    });

    return (
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>Entrepreneurs Management</Typography>
        
        <Box sx={{ mb: 3 }}>
          <TextField
            placeholder="Search by name or email"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 300 }}
            InputProps={{
              startAdornment: <Typography sx={{ mr: 1 }}>🔍</Typography>
            }}
          />
        </Box>

        <TableContainer component={Paper} sx={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f8fafc' }}>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Entrepreneur</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Email</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>KYC</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Projects</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Subsidy Apps</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredUsers.map((user) => (
                <TableRow key={user.id} sx={{ '&:hover': { bgcolor: '#f8fafc' } }}>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <Typography 
                      sx={{ fontWeight: 500, cursor: 'pointer', color: '#1976d2' }}
                      onClick={async () => {
                        setSelectedEntrepreneur(user);
                        await loadEntrepreneurProjects(user.id);
                        setOpenEntrepreneurDialog(true);
                      }}
                    >
                      {user.username || user.name || 'Unknown'}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>{user.email || 'N/A'}</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column', alignItems: 'center' }}>
                      <Chip 
                        label={user.kyc || (user.is_active ? 'Active' : 'Inactive')}
                        color={user.kyc === 'Verified' || user.is_active ? 'success' : 'warning'}
                        size="small"
                      />
                      {user.is_active === false && (
                        <Chip 
                          label="Deactivated"
                          color="error"
                          size="small"
                        />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>{user.projects_count || 0}</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>{user.subsidyApps || 0}</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <IconButton 
                      size="small" 
                      title="View Details"
                      onClick={async () => {
                        setSelectedEntrepreneur(user);
                        await loadEntrepreneurProjects(user.id);
                        setOpenEntrepreneurDialog(true);
                      }}
                    >
                      <Typography>👁️</Typography>
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination for Entrepreneurs */}
        {totalPages > 1 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <IconButton 
                size="small" 
                disabled={currentPage === 1}
                onClick={() => loadUsers(currentPage - 1)}
              >
                ‹
              </IconButton>
              {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                const page = i + 1;
                return (
                  <Button 
                    key={page}
                    variant={currentPage === page ? "contained" : "outlined"} 
                    size="small" 
                    sx={{ minWidth: 32, height: 32 }}
                    onClick={() => loadUsers(page)}
                  >
                    {page}
                  </Button>
                );
              })}
              <IconButton 
                size="small" 
                disabled={currentPage === totalPages}
                onClick={() => loadUsers(currentPage + 1)}
              >
                ›
              </IconButton>
            </Box>
          </Box>
        )}
        
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
            {((currentPage - 1) * 10) + 1}-{Math.min(currentPage * 10, totalCount)} of {totalCount} entrepreneurs
          </Typography>
        </Box>
      </Box>
    );
  };

  const handleAssignConsultant = async (projectId, consultantName) => {
    try {
      // Find consultant by name
      const consultant = staff.find(member => 
        (member.username || member.name) === consultantName
      );
      
      if (consultant) {
        await apiService.assignConsultant(projectId, consultant.id);
        // Reload projects to get updated data
        await loadProjectsPage(projectsPage);
      }
    } catch (error) {
      console.error('Error assigning consultant:', error);
      alert('Failed to assign consultant. Please try again.');
    }
  };

  const handleDocumentStatusChange = async (projectId, documentType, newStatus) => {
    try {
      // Get the user ID from the selected project
      const userId = selectedProject.entrepreneur;
      
      // Update document status via user API instead of project API
      await apiService.updateUserDocumentStatus(userId, documentType, newStatus);
      
      // Update the selected project in state immediately for better UX
      if (selectedProject && selectedProject.id === projectId) {
        const updatedProject = { ...selectedProject };
        if (documentType === 'aadhar') {
          updatedProject.aadhar_document_status = newStatus;
          updatedProject.aadhar_document_status_display = newStatus.charAt(0).toUpperCase() + newStatus.slice(1).replace('_', ' ');
        } else if (documentType === 'pan') {
          updatedProject.pan_document_status = newStatus;
          updatedProject.pan_document_status_display = newStatus.charAt(0).toUpperCase() + newStatus.slice(1).replace('_', ' ');
        }
        // Update documents_fully_approved property
        updatedProject.documents_fully_approved = 
          updatedProject.aadhar_document_status === 'approved' && 
          updatedProject.pan_document_status === 'approved';
        
        setSelectedProject(updatedProject);
      }
      
      // Reload projects to get updated data
      await loadProjectsPage(projectsPage);
    } catch (error) {
      console.error('Error updating document status:', error);
      alert('Failed to update document status. Please try again.');
    }
  };

  const handleUserDocumentStatusChange = async (userId, documentType, newStatus) => {
    try {
      // Update document status via user API
      await apiService.updateUserDocumentStatus(userId, documentType, newStatus);
      
      // Reload entrepreneur projects to get updated data
      await loadEntrepreneurProjects(userId);
      
      // Also reload projects if we're viewing the same user's project
      if (selectedProject && selectedProject.entrepreneur === userId) {
        await loadProjectsPage(projectsPage);
      }
      
      alert('Document status updated successfully!');
    } catch (error) {
      console.error('Error updating user document status:', error);
      alert('Failed to update document status. Please try again.');
    }
  };

  const [projectsPage, setProjectsPage] = useState(1);
  const [projectsTotalPages, setProjectsTotalPages] = useState(1);
  const [projectsTotalCount, setProjectsTotalCount] = useState(0);

  const loadProjectsPage = async (page = 1) => {
    try {
      const response = await apiService.getProjects(page);
      const data = response.data;
      const projectsData = data.results || data || [];

      setProjects(projectsData);
      setProjectsTotalCount(data.count || projectsData.length);
      setProjectsTotalPages(Math.ceil((data.count || projectsData.length) / 10));
      setProjectsPage(page);
      if (data.count) {
        setTotalProjects(data.count);
      }
    } catch (error) {
      console.error('Error loading projects:', error);
      setProjects([]);
    }
  };

  const renderProjects = () => {
    const filteredProjects = projects.filter(project => {
      return (!statusFilter || project.status_display === statusFilter) &&
             (!consultantFilter || project.consultant_name === consultantFilter);
    });


    return (
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 4 }}>Projects</Typography>
        
        {/* Filters Row */}
        <Box sx={{ display: 'flex', gap: 2, mb: 3, alignItems: 'center' }}>
          <FormControl sx={{ minWidth: 120 }} size="small">
            <InputLabel>Status</InputLabel>
            <Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              label="Status"
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="Approved">Approved</MenuItem>
              <MenuItem value="Under Review">Under Review</MenuItem>
              <MenuItem value="Rejected">Rejected</MenuItem>
              <MenuItem value="Submitted">Submitted</MenuItem>
            </Select>
          </FormControl>
          
          <FormControl sx={{ minWidth: 150 }} size="small">
            <InputLabel>Consultant</InputLabel>
            <Select
              value={consultantFilter}
              onChange={(e) => setConsultantFilter(e.target.value)}
              label="Consultant"
            >
              <MenuItem value="">All</MenuItem>
              {staff.map(member => (
                <MenuItem key={member.id} value={member.username}>
                  {member.first_name && member.last_name 
                    ? `${member.first_name} ${member.last_name}` 
                    : member.username || 'Unknown'}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <Button variant="contained" sx={{ bgcolor: '#1976d2', height: 40 }}>Apply Filter</Button>
        </Box>

        {/* Bulk Actions */}
        <Box sx={{ display: 'flex', gap: 2, mb: 3, alignItems: 'center' }}>
          <FormControl sx={{ minWidth: 180 }} size="small">
            <InputLabel>Bulk Actions</InputLabel>
            <Select
              value={bulkAction}
              onChange={(e) => setBulkAction(e.target.value)}
              label="Bulk Actions"
            >
              <MenuItem value="approve">Approve Selected</MenuItem>
              <MenuItem value="reject">Reject Selected</MenuItem>
              <MenuItem value="assign">Assign Consultant</MenuItem>
            </Select>
          </FormControl>
          <Button variant="outlined" sx={{ height: 40 }}>Go</Button>
        </Box>

        {/* Projects Table */}
        <TableContainer component={Paper} sx={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f8fafc' }}>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Project Name</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Entrepreneur</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Stage</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Consultant</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Last Updated</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredProjects.map((project) => {
                const getStageColor = (status) => {
                  switch(status) {
                    case 'Approved': return { bgcolor: '#e8f5e8', color: '#2e7d32' };
                    case 'Under Review': return { bgcolor: '#fff3e0', color: '#f57c00' };
                    case 'Rejected': return { bgcolor: '#ffebee', color: '#d32f2f' };
                    case 'Submitted': return { bgcolor: '#e3f2fd', color: '#1976d2' };
                    default: return { bgcolor: '#f5f5f5', color: '#666' };
                  }
                };

                return (
                  <TableRow key={project.id} sx={{ '&:hover': { bgcolor: '#f8fafc' } }}>
                    <TableCell sx={{ textAlign: 'center' }}>
                      <Typography 
                        sx={{ fontWeight: 500, cursor: 'pointer', color: '#1976d2' }}
                        onClick={() => {
                          setSelectedProject(project);
                          setOpenProjectDialog(true);
                        }}
                      >
                        {project.name}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ textAlign: 'center' }}>
                      {project.entrepreneur_name || project.entrepreneur || 'Unknown User'}
                    </TableCell>
                    <TableCell sx={{ textAlign: 'center' }}>
                      <Box 
                        sx={{ 
                          display: 'inline-block',
                          px: 2, 
                          py: 0.5, 
                          borderRadius: 1,
                          fontSize: '12px',
                          fontWeight: 500,
                          ...getStageColor(project.status_display)
                        }}
                      >
                        {project.status_display}
                      </Box>
                    </TableCell>
                    <TableCell sx={{ textAlign: 'center' }}>
                      {project.consultant_name || project.assignedConsultant ? (
                        <FormControl size="small" sx={{ minWidth: 120 }}>
                          <Select
                            value={project.consultant_name || project.assignedConsultant}
                            onChange={(e) => handleAssignConsultant(project.id, e.target.value)}
                          >
                            {staff.map(member => (
                              <MenuItem key={member.id} value={member.username || member.name}>{member.username || member.name}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      ) : (
                        <FormControl size="small" sx={{ minWidth: 150 }}>
                          <Select
                            value=""
                            onChange={(e) => handleAssignConsultant(project.id, e.target.value)}
                            displayEmpty
                          >
                            <MenuItem value="" disabled>Not assigned</MenuItem>
                            {staff.map(member => (
                              <MenuItem key={member.id} value={member.username || member.name}>{member.username || member.name}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </TableCell>
                    <TableCell sx={{ textAlign: 'center' }}>{project.lastUpdated || '04/21/2024'}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        
        {/* Pagination */}
        {projectsTotalPages > 1 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <IconButton 
                size="small" 
                disabled={projectsPage === 1}
                onClick={() => loadProjectsPage(projectsPage - 1)}
              >
                ‹
              </IconButton>
              {Array.from({ length: Math.min(projectsTotalPages, 5) }, (_, i) => {
                const page = i + 1;
                return (
                  <Button 
                    key={page}
                    variant={projectsPage === page ? "contained" : "outlined"} 
                    size="small" 
                    sx={{ minWidth: 32, height: 32 }}
                    onClick={() => loadProjectsPage(page)}
                  >
                    {page}
                  </Button>
                );
              })}
              <IconButton 
                size="small" 
                disabled={projectsPage === projectsTotalPages}
                onClick={() => loadProjectsPage(projectsPage + 1)}
              >
                ›
              </IconButton>
            </Box>
          </Box>
        )}
        
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {((projectsPage - 1) * 10) + 1}-{Math.min(projectsPage * 10, projectsTotalCount)} of {projectsTotalCount} projects
          </Typography>
        </Box>
      </Box>
    );
  };

  const handleConsultantClick = (consultant) => {
    setSelectedConsultant(consultant);
    setOpenConsultantDialog(true);
  };

  const handleToggleConsultantStatus = async (consultantId) => {
    try {
      const consultant = staff.find(member => member.id === consultantId);
      if (consultant.is_active) {
        await apiService.deactivateUser(consultantId);
      } else {
        await apiService.activateUser(consultantId);
      }
      await loadStaff();
    } catch (error) {
      console.error('Error toggling consultant status:', error);
      alert('Failed to update consultant status. Please try again.');
    }
  };

  const handleDeactivateUser = async (userId) => {
    if (window.confirm('Are you sure you want to deactivate this user? They will not be able to login until reactivated.')) {
      try {
        await apiService.deactivateUser(userId);
        await loadUsers();
        setOpenEntrepreneurDialog(false);
        alert('User deactivated successfully');
      } catch (error) {
        console.error('Error deactivating user:', error);
        alert('Failed to deactivate user. Please try again.');
      }
    }
  };

  const handleActivateUser = async (userId) => {
    try {
      await apiService.activateUser(userId);
      await loadUsers();
      setOpenEntrepreneurDialog(false);
      alert('User activated successfully');
    } catch (error) {
      console.error('Error activating user:', error);
      alert('Failed to activate user. Please try again.');
    }
  };

  const handleEditUser = (user) => {
    // For now, just show an alert. In a full implementation, you'd open an edit dialog
    alert('Edit user functionality would open a form to edit user details.');
  };

  const renderConsultants = () => {
    const filteredStaff = staff.filter(member => {
      if (!member) return false;
      const name = member.name || '';
      const email = member.email || '';
      return name.toLowerCase().includes(searchTerm.toLowerCase()) ||
             email.toLowerCase().includes(searchTerm.toLowerCase());
    });

    return (
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>Consultants Management</Typography>
          <Button 
            variant="contained" 
            startIcon={<Add />} 
            onClick={() => setOpenStaffDialog(true)}
            sx={{ bgcolor: '#3b82f6' }}
          >
            Add Staff
          </Button>
        </Box>
        
        <Box sx={{ mb: 3 }}>
          <TextField
            placeholder="Search by name or email"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 300 }}
            InputProps={{
              startAdornment: <Typography sx={{ mr: 1 }}>🔍</Typography>
            }}
          />
        </Box>

        <TableContainer component={Paper} sx={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f8fafc' }}>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Email</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Designation</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredStaff.map((member) => (
                <TableRow 
                  key={member.id} 
                  sx={{ 
                    '&:hover': { bgcolor: '#f8fafc' },
                    cursor: 'pointer'
                  }}
                  onClick={() => handleConsultantClick(member)}
                >
                  <TableCell sx={{ textAlign: 'center' }}>
                    <Typography sx={{ fontWeight: 500 }}>
                      {member.first_name && member.last_name 
                        ? `${member.first_name} ${member.last_name}` 
                        : member.username || 'Unknown'}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>{member.email || 'N/A'}</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>{member.phone || member.profile?.phone || 'N/A'}</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>{member.designation || member.profile?.designation || 'Consultant'}</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <Chip 
                      label={member.is_active ? 'Active' : 'Inactive'}
                      color={member.is_active ? 'success' : 'default'}
                      size="small"
                      onClick={() => handleToggleConsultantStatus(member.id)}
                      sx={{ cursor: 'pointer' }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination for Consultants */}
        {consultantsTotalPages > 1 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <IconButton 
                size="small" 
                disabled={consultantsPage === 1}
                onClick={() => loadStaff(consultantsPage - 1)}
              >
                ‹
              </IconButton>
              {Array.from({ length: Math.min(consultantsTotalPages, 5) }, (_, i) => {
                const page = i + 1;
                return (
                  <Button 
                    key={page}
                    variant={consultantsPage === page ? "contained" : "outlined"} 
                    size="small" 
                    sx={{ minWidth: 32, height: 32 }}
                    onClick={() => loadStaff(page)}
                  >
                    {page}
                  </Button>
                );
              })}
              <IconButton 
                size="small" 
                disabled={consultantsPage === consultantsTotalPages}
                onClick={() => loadStaff(consultantsPage + 1)}
              >
                ›
              </IconButton>
            </Box>
          </Box>
        )}
        
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {((consultantsPage - 1) * 10) + 1}-{Math.min(consultantsPage * 10, consultantsTotalCount)} of {consultantsTotalCount} consultants
          </Typography>
        </Box>
      </Box>
    );
  };



  const renderSchemes = () => {
    const filteredSchemes = schemes.filter(scheme => {
      if (!scheme) return false;
      const title = scheme.title || '';
      const category = scheme.category || '';
      return title.toLowerCase().includes(searchTerm.toLowerCase()) ||
             category.toLowerCase().includes(searchTerm.toLowerCase());
    });

    return (
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>Schemes Management</Typography>
          <Button 
            variant="contained" 
            startIcon={<Add />} 
            onClick={() => setOpenSchemeDialog(true)}
            sx={{ bgcolor: '#3b82f6' }}
          >
            Add Scheme
          </Button>
        </Box>
        
        <Box sx={{ mb: 3 }}>
          <TextField
            placeholder="Search by title or category"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 300 }}
            InputProps={{
              startAdornment: <Typography sx={{ mr: 1 }}>🔍</Typography>
            }}
          />
        </Box>

        <TableContainer component={Paper} sx={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f8fafc' }}>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Scheme Title</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Category</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Benefits</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Deadline</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredSchemes.map((scheme) => (
                <TableRow key={scheme.id} sx={{ '&:hover': { bgcolor: '#f8fafc' } }}>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <Typography 
                      sx={{ fontWeight: 500, cursor: 'pointer', color: '#1976d2' }}
                      onClick={() => {
                        setSelectedScheme(scheme);
                        setOpenSchemeDetailDialog(true);
                      }}
                    >
                      {scheme.title}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <Chip 
                      label={scheme.category || 'General'}
                      color="primary"
                      variant="outlined"
                      size="small"
                    />
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center', maxWidth: 200 }}>
                    <Typography variant="body2" sx={{ 
                      overflow: 'hidden', 
                      textOverflow: 'ellipsis', 
                      whiteSpace: 'nowrap' 
                    }}>
                      {scheme.benefits || 'N/A'}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <Typography variant="body2">
                      {scheme.deadline ? new Date(scheme.deadline).toLocaleDateString() : 'No deadline'}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <Chip 
                      label={scheme.status === 'active' ? 'Active' : 'Inactive'}
                      color={scheme.status === 'active' ? 'success' : 'default'}
                      size="small"
                      onClick={() => handleToggleSchemeStatus(scheme.id)}
                      sx={{ cursor: 'pointer' }}
                    />
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <IconButton 
                      size="small" 
                      title="Edit Scheme"
                      onClick={() => handleEditScheme(scheme)}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton 
                      size="small" 
                      title="Delete Scheme"
                      onClick={() => handleDeleteScheme(scheme)}
                      color="error"
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        
        {filteredSchemes.length === 0 && (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body2" color="text.secondary">
              {schemes.length === 0 ? 'No schemes available' : 'No schemes match your search'}
            </Typography>
          </Box>
        )}
      </Box>
    );
  };



  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Blue Sidebar */}
      <Box sx={{ 
        width: 280, 
        bgcolor: '#1e3a8a', 
        color: 'white',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Logo Section */}
        <Box sx={{ p: 3, borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <img src={logo} alt="TICSPL" style={{ height: '40px', marginRight: '12px' }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: 'white' }}>
              TICSPL
            </Typography>
          </Box>
        </Box>

        {/* Navigation Menu */}
        <Box sx={{ flex: 1, py: 2 }}>
          {[
            { label: 'Dashboard', value: 0 },
            { label: 'Projects', value: 1 },
            { label: 'Entrepreneurs', value: 2 },
            { label: 'Consultants', value: 3 },
            { label: 'Schemes', value: 4 },
            { label: 'KYC & Documents', value: 5 },
            { label: 'Services', value: 6 }
          ].map((item) => (
            <Box
              key={item.value}
              onClick={() => setActiveTab(item.value)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                px: 3,
                py: 2,
                cursor: 'pointer',
                bgcolor: activeTab === item.value ? 'rgba(255,255,255,0.1)' : 'transparent',
                '&:hover': {
                  bgcolor: 'rgba(255,255,255,0.05)'
                }
              }}
            >
              <Typography sx={{ fontWeight: activeTab === item.value ? 600 : 400 }}>
                {item.label}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Admin Profile at Bottom */}
        <Box sx={{ p: 3, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              cursor: 'pointer',
              p: 1,
              borderRadius: 1,
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.05)'
              }
            }} 
            onClick={handleMenuOpen}
          >
            <Avatar sx={{ width: 32, height: 32, bgcolor: 'rgba(255,255,255,0.2)', mr: 2 }}>👤</Avatar>
            <Typography sx={{ fontWeight: 500 }}>Admin</Typography>
          </Box>
        </Box>
        
        {/* Admin Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <MenuItemComponent onClick={() => {
            handleMenuClose();
            const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
            setAdminProfileData({
              username: userInfo.username || '',
              email: userInfo.email || '',
              first_name: userInfo.first_name || '',
              last_name: userInfo.last_name || '',
              phone: userInfo.phone || '',
              current_password: '',
              new_password: '',
              confirm_password: ''
            });
            setOpenAdminProfileDialog(true);
          }}>Profile</MenuItemComponent>
          <MenuItemComponent onClick={handleLogout}>Logout</MenuItemComponent>
        </Menu>
      </Box>

      {/* Main Content Area */}
      <Box sx={{ flex: 1, bgcolor: '#f8fafc' }}>
        {/* Top Header */}
        <Box sx={{ 
          bgcolor: 'white', 
          p: 3, 
          borderBottom: '1px solid #e2e8f0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="h4" sx={{ fontWeight: 600, color: '#1e293b' }}>
            Admin Dashboard
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconButton>
              <NotificationsOutlined />
            </IconButton>
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                cursor: 'pointer',
                p: 1,
                borderRadius: 1,
                '&:hover': {
                  bgcolor: '#f1f5f9'
                }
              }}
              onClick={handleMenuOpen}
            >
              <Typography sx={{ color: '#64748b', mr: 1 }}>👤 Admin</Typography>
            </Box>
          </Box>
        </Box>

        {/* Dashboard Content */}
        <Box sx={{ p: 4 }}>
          {activeTab === 0 && renderNewDashboard()}
          {activeTab === 1 && renderProjects()}
          {activeTab === 2 && renderEntrepreneurs()}
          {activeTab === 3 && renderConsultants()}
          {activeTab === 4 && renderSchemes()}
          {activeTab === 6 && <AdminServicesPage />}
        </Box>
      </Box>

      {/* Add Staff Dialog */}
      <Dialog open={openStaffDialog} onClose={() => setOpenStaffDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {editingStaff ? 'Edit Staff Member' : 'Add New Staff Member'}
            <IconButton onClick={() => {
              setOpenStaffDialog(false);
              setEditingStaff(null);
              setStaffData({ name: '', email: '', phone: '', specialization: '', designation: '', password: '', assignedProjects: [] });
            }}>
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Full Name"
                value={staffData.name}
                onChange={(e) => setStaffData({...staffData, name: e.target.value})}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                value={staffData.email}
                onChange={(e) => setStaffData({...staffData, email: e.target.value})}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Phone"
                value={staffData.phone}
                onChange={(e) => setStaffData({...staffData, phone: e.target.value})}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="password"
                label="Password"
                value={staffData.password}
                onChange={(e) => setStaffData({...staffData, password: e.target.value})}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Specialization</InputLabel>
                <Select
                  value={staffData.specialization}
                  onChange={(e) => setStaffData({...staffData, specialization: e.target.value})}
                >
                  <MenuItem value="Food Processing">Food Processing</MenuItem>
                  <MenuItem value="Textile">Textile</MenuItem>
                  <MenuItem value="Engineering">Engineering</MenuItem>
                  <MenuItem value="Electronics">Electronics</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Designation</InputLabel>
                <Select
                  value={staffData.designation}
                  onChange={(e) => setStaffData({...staffData, designation: e.target.value})}
                >
                  <MenuItem value="Consultant">Consultant</MenuItem>
                  <MenuItem value="Senior Consultant">Senior Consultant</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 2 }}>Assign Projects</Typography>
              <Box sx={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
                {projects.map((project) => (
                  <Box 
                    key={project.id}
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      p: 1, 
                      cursor: 'pointer',
                      '&:hover': { bgcolor: '#f5f5f5' },
                      borderRadius: 1,
                      mb: 1
                    }}
                    onClick={() => {
                      const currentAssigned = staffData.assignedProjects || [];
                      const newAssigned = currentAssigned.includes(project.id)
                        ? currentAssigned.filter(id => id !== project.id)
                        : [...currentAssigned, project.id];
                      setStaffData({...staffData, assignedProjects: newAssigned});
                    }}
                  >
                    <Box 
                      sx={{ 
                        width: 20, 
                        height: 20, 
                        border: '2px solid #1976d2', 
                        borderRadius: 1, 
                        mr: 2,
                        bgcolor: (staffData.assignedProjects || []).includes(project.id) ? '#1976d2' : 'transparent',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {(staffData.assignedProjects || []).includes(project.id) && (
                        <Typography sx={{ color: 'white', fontSize: '12px' }}>✓</Typography>
                      )}
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>{project.name}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        {project.type} - {project.investment}
                      </Typography>
                    </Box>
                    <Chip 
                      label={project.status} 
                      color={project.status === 'Approved' ? 'success' : project.status === 'Rejected' ? 'error' : 'warning'}
                      size="small"
                    />
                  </Box>
                ))}
                {projects.length === 0 && (
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
                    No projects available
                  </Typography>
                )}
              </Box>
              <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                Selected: {(staffData.assignedProjects || []).length} project(s)
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpenStaffDialog(false);
            setEditingStaff(null);
            setStaffData({ name: '', email: '', phone: '', specialization: '', designation: '', password: '', assignedProjects: [] });
          }}>Cancel</Button>
          <Button variant="contained" onClick={handleAddStaff}>
            {editingStaff ? 'Update Staff' : 'Add Staff'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add/Edit Scheme Dialog */}
      <Dialog open={openSchemeDialog} onClose={() => {
        setOpenSchemeDialog(false);
        setEditingScheme(null);
        setSchemeData({ title: '', description: '', eligibility: '', benefits: '', deadline: '', region: '', subsidy_amount: '', policy_validity: '', category: 'msme' });
      }} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {editingScheme ? 'Edit Scheme' : 'Add New Scheme'}
            <IconButton onClick={() => {
              setOpenSchemeDialog(false);
              setEditingScheme(null);
              setSchemeData({ title: '', description: '', eligibility: '', benefits: '', deadline: '', region: '', subsidy_amount: '', policy_validity: '', category: 'msme' });
            }}>
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
            <TextField
              fullWidth
              label="Scheme Title"
              value={schemeData.title}
              onChange={(e) => setSchemeData({...schemeData, title: e.target.value})}
            />
            
            <FormControl fullWidth>
              <InputLabel>Category</InputLabel>
              <Select
                value={schemeData.category}
                onChange={(e) => setSchemeData({...schemeData, category: e.target.value})}
                label="Category"
              >
                <MenuItem value="manufacturing">Manufacturing</MenuItem>
                <MenuItem value="startup">Startup</MenuItem>
                <MenuItem value="technology">Technology</MenuItem>
                <MenuItem value="export">Export</MenuItem>
                <MenuItem value="msme">MSME</MenuItem>
                <MenuItem value="agriculture">Agriculture</MenuItem>
                <MenuItem value="renewable_energy">Renewable Energy</MenuItem>
              </Select>
            </FormControl>
            
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Description"
              value={schemeData.description}
              onChange={(e) => setSchemeData({...schemeData, description: e.target.value})}
            />
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Eligibility Criteria"
              value={schemeData.eligibility}
              onChange={(e) => setSchemeData({...schemeData, eligibility: e.target.value})}
            />
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Benefits"
              value={schemeData.benefits}
              onChange={(e) => setSchemeData({...schemeData, benefits: e.target.value})}
            />
            <TextField
              fullWidth
              label="Region / District"
              value={schemeData.region}
              onChange={(e) => setSchemeData({...schemeData, region: e.target.value})}
              placeholder="e.g., Andhra Pradesh, Visakhapatnam"
            />
            <TextField
              fullWidth
              type="number"
              label="Subsidy Limit (in Lakhs)"
              value={schemeData.subsidy_amount}
              onChange={(e) => setSchemeData({...schemeData, subsidy_amount: e.target.value})}
              placeholder="e.g., 25"
              inputProps={{ step: "0.01", min: "0" }}
            />
            <TextField
              fullWidth
              label="Policy Validity"
              value={schemeData.policy_validity}
              onChange={(e) => setSchemeData({...schemeData, policy_validity: e.target.value})}
              placeholder="e.g., 2024 - 2029"
              helperText="Enter the validity period (e.g., 2024 - 2029)"
            />
            <TextField
              fullWidth
              type="date"
              label="Deadline"
              InputLabelProps={{ shrink: true }}
              value={schemeData.deadline}
              onChange={(e) => setSchemeData({...schemeData, deadline: e.target.value})}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpenSchemeDialog(false);
            setEditingScheme(null);
            setSchemeData({ title: '', description: '', eligibility: '', benefits: '', deadline: '', region: '', subsidy_amount: '', policy_validity: '', category: 'msme' });
          }}>Cancel</Button>
          <Button variant="contained" onClick={handleAddScheme}>
            {editingScheme ? 'Update Scheme' : 'Add Scheme'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Scheme Details Dialog */}
      <Dialog 
        open={openSchemeDetailDialog} 
        onClose={() => setOpenSchemeDetailDialog(false)} 
        maxWidth="lg" 
        fullWidth
        PaperProps={{
          sx: { minHeight: '80vh' }
        }}
      >
        <Box sx={{ minHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
          {selectedScheme && (
            <>
              {/* Header */}
              <Box sx={{ p: 3, borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
                    {selectedScheme.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {selectedScheme.category || 'General'} Scheme
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Button variant="outlined" onClick={() => handleEditScheme(selectedScheme)}>Edit Scheme</Button>
                  <Button variant="outlined" color="error" onClick={() => handleDeleteScheme(selectedScheme)}>Delete Scheme</Button>
                  <IconButton onClick={() => setOpenSchemeDetailDialog(false)}><Close /></IconButton>
                </Box>
              </Box>
              

              
              {/* Content */}
              <Box sx={{ flex: 1, p: 4 }}>
                <Grid container spacing={4}>
                  {/* Left Column - Scheme Details */}
                  <Grid item xs={12} md={8}>
                    <Box sx={{ mb: 4 }}>
                      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1976d2' }}>Description</Typography>
                      <Box sx={{ p: 3, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                        <Typography variant="body1">
                          {selectedScheme.description || 'No description provided'}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ mb: 4 }}>
                      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1976d2' }}>Eligibility Criteria</Typography>
                      <Box sx={{ p: 3, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                        <Typography variant="body1">
                          {selectedScheme.eligibility || 'No eligibility criteria specified'}
                        </Typography>
                      </Box>
                    </Box>

                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1976d2' }}>Benefits</Typography>
                      <Box sx={{ p: 3, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                        <Typography variant="body1">
                          {selectedScheme.benefits || 'No benefits specified'}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  {/* Right Column - Scheme Info */}
                  <Grid item xs={12} md={4}>
                    <Box sx={{ mb: 3 }}>
                      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1976d2' }}>Scheme Information</Typography>
                      
                      <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>Status</Typography>
                        <Chip 
                          label={selectedScheme.status === 'active' ? 'Active' : 'Inactive'}
                          color={selectedScheme.status === 'active' ? 'success' : 'default'}
                          size="small"
                          sx={{ mt: 1 }}
                        />
                      </Box>

                      <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>Category</Typography>
                        <Typography variant="body2">{selectedScheme.category || 'General'}</Typography>
                      </Box>

                      <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>Deadline</Typography>
                        <Typography variant="body2">
                          {selectedScheme.deadline ? new Date(selectedScheme.deadline).toLocaleDateString() : 'No deadline set'}
                        </Typography>
                      </Box>

                      <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>Created</Typography>
                        <Typography variant="body2">
                          {selectedScheme.created_at ? new Date(selectedScheme.created_at).toLocaleDateString() : 'N/A'}
                        </Typography>
                      </Box>
                    </Box>

                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1976d2' }}>Quick Actions</Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Button 
                          variant="contained" 
                          onClick={() => handleToggleSchemeStatus(selectedScheme.id)}
                          color={selectedScheme.status === 'active' ? 'warning' : 'success'}
                        >
                          {selectedScheme.status === 'active' ? 'Deactivate Scheme' : 'Activate Scheme'}
                        </Button>
                        <Button 
                          variant="outlined" 
                          onClick={() => {
                            handleEditScheme(selectedScheme);
                            setOpenSchemeDetailDialog(false);
                          }}
                        >
                          Edit Details
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </>
          )}
        </Box>
      </Dialog>



      {/* Project Assignment Dialog */}
      <Dialog open={openAssignDialog} onClose={() => setOpenAssignDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          Assign Projects to {selectedStaff?.name}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Select projects to assign to this staff member:
          </Typography>
          <Grid container spacing={2}>
            {projects.map((project) => (
              <Grid item xs={12} key={project.id}>
                <Card 
                  sx={{ 
                    cursor: 'pointer',
                    border: selectedStaff?.assignedProjects?.includes(project.id) ? '2px solid #1976d2' : '1px solid #e0e0e0'
                  }}
                  onClick={() => {
                    const currentAssigned = selectedStaff?.assignedProjects || [];
                    const newAssigned = currentAssigned.includes(project.id)
                      ? currentAssigned.filter(id => id !== project.id)
                      : [...currentAssigned, project.id];
                    setSelectedStaff({...selectedStaff, assignedProjects: newAssigned});
                  }}
                >
                  <CardContent sx={{ py: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Box>
                        <Typography variant="h6">{project.name}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          {project.type} - {project.investment}
                        </Typography>
                      </Box>
                      <Chip 
                        label={project.status} 
                        color={project.status === 'Approved' ? 'success' : project.status === 'Rejected' ? 'error' : 'warning'}
                      />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAssignDialog(false)}>Cancel</Button>
          <Button 
            variant="contained" 
            onClick={() => {
              handleAssignProjects(selectedStaff.id, selectedStaff.assignedProjects || []);
              setOpenAssignDialog(false);
              setSelectedStaff(null);
            }}
          >
            Assign Projects
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Staff Confirmation Dialog */}
      <Dialog open={deleteStaffDialog} onClose={() => setDeleteStaffDialog(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete staff member "{staffToDelete?.name}"? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteStaffDialog(false)}>Cancel</Button>
          <Button onClick={confirmDeleteStaff} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Consultant Details Dialog */}
      <Dialog 
        open={openConsultantDialog} 
        onClose={() => setOpenConsultantDialog(false)} 
        maxWidth="md" 
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Consultant Details
            <IconButton onClick={() => setOpenConsultantDialog(false)}>
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedConsultant && (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <Avatar 
                      sx={{ 
                        width: 120, 
                        height: 120, 
                        mx: 'auto', 
                        mb: 2, 
                        bgcolor: '#3b82f6',
                        fontSize: '48px'
                      }}
                    >
                      {(selectedConsultant.name || 'C').charAt(0)}
                    </Avatar>
                    <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                      {selectedConsultant.name}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                      {selectedConsultant.designation || 'Consultant'}
                    </Typography>
                    <Chip 
                      label={selectedConsultant.is_active ? 'Active' : 'Inactive'}
                      color={selectedConsultant.is_active ? 'success' : 'default'}
                      sx={{ mb: 2 }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={8}>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>Contact Information</Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">Email</Typography>
                        <Typography variant="body1">{selectedConsultant.email || 'N/A'}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">Phone</Typography>
                        <Typography variant="body1">{selectedConsultant.phone || 'N/A'}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">Specialization</Typography>
                        <Typography variant="body1">{selectedConsultant.specialization || 'N/A'}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">Assigned Projects</Typography>
                        <Typography variant="body1">{(selectedConsultant.assigned_projects || selectedConsultant.assignedProjects || []).length}</Typography>
                      </Box>
                    </Grid>
                  </Grid>
                  
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, mt: 3 }}>Account Status</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography variant="body1">
                      Status: {selectedConsultant.is_active ? 'Active' : 'Inactive'}
                    </Typography>
                    <Button
                      variant={selectedConsultant.is_active ? 'outlined' : 'contained'}
                      color={selectedConsultant.is_active ? 'error' : 'success'}
                      onClick={() => handleToggleConsultantStatus(selectedConsultant.id)}
                      size="small"
                    >
                      {selectedConsultant.is_active ? 'Deactivate' : 'Activate'}
                    </Button>
                  </Box>
                  
                  {selectedConsultant.createdAt && (
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="body2" color="text.secondary">
                        Joined: {new Date(selectedConsultant.createdAt).toLocaleDateString()}
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              handleDeleteStaff(selectedConsultant);
              setOpenConsultantDialog(false);
            }}
            startIcon={<Delete />}
            color="error"
          >
            Delete Consultant
          </Button>
          <Button 
            onClick={() => {
              handleEditStaff(selectedConsultant);
              setOpenConsultantDialog(false);
            }}
            startIcon={<Edit />}
          >
            Edit Details
          </Button>
          <Button onClick={() => setOpenConsultantDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Entrepreneur Profile Dialog */}
      <Dialog 
        open={openEntrepreneurDialog} 
        onClose={() => setOpenEntrepreneurDialog(false)} 
        maxWidth="xl" 
        fullWidth
        PaperProps={{
          sx: { minHeight: '90vh', maxHeight: '90vh' }
        }}
      >
        <Box sx={{ height: '90vh', display: 'flex', flexDirection: 'column' }}>
          {selectedEntrepreneur && (
            <>
              {/* Header */}
              <Box sx={{ p: 3, borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
                    {selectedEntrepreneur.first_name && selectedEntrepreneur.last_name 
                      ? `${selectedEntrepreneur.first_name} ${selectedEntrepreneur.last_name}` 
                      : selectedEntrepreneur.username || 'Unknown User'}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    Entrepreneur
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Button variant="contained" onClick={() => handleEditUser(selectedEntrepreneur)}>Edit Profile</Button>
                  {selectedEntrepreneur?.is_active ? (
                    <Button variant="outlined" color="error" onClick={() => handleDeactivateUser(selectedEntrepreneur.id)}>Deactivate Profile</Button>
                  ) : (
                    <Button variant="contained" color="success" onClick={() => handleActivateUser(selectedEntrepreneur.id)}>Activate Profile</Button>
                  )}
                  <IconButton onClick={() => setOpenEntrepreneurDialog(false)}><Close /></IconButton>
                </Box>
              </Box>

              {/* 4-Column Layout */}
              <Box sx={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
                {/* Column 1: User Information */}
                <Box sx={{ width: '25%', p: 3, borderRight: '1px solid #e0e0e0', overflowY: 'auto' }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, textAlign: 'center', color: '#1976d2' }}>User Information</Typography>
                  
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Contact Details</Typography>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>Email</Typography>
                      <Typography variant="body2">{selectedEntrepreneur.email || 'Not provided'}</Typography>
                    </Box>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>Phone</Typography>
                      <Typography variant="body2">+91 {selectedEntrepreneur.phone || selectedEntrepreneur.profile?.phone || 'Not provided'}</Typography>
                    </Box>
                  </Box>

                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Account Status</Typography>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                      <Chip 
                        label={selectedEntrepreneur.is_active ? 'Active Account' : 'Deactivated Account'}
                        color={selectedEntrepreneur.is_active ? 'success' : 'error'}
                        size="small"
                      />
                    </Box>
                  </Box>

                  <Box>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Verification Status</Typography>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography>📧</Typography>
                        <Typography variant="body2">Email Verification</Typography>
                        <Chip label={selectedEntrepreneur.is_active ? "Verified" : "Pending"} color={selectedEntrepreneur.is_active ? "success" : "warning"} size="small" />
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {/* Column 2: Projects */}
                <Box sx={{ width: '25%', p: 3, borderRight: '1px solid #e0e0e0', overflowY: 'auto' }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, textAlign: 'center', color: '#1976d2' }}>Projects ({entrepreneurProjects.length})</Typography>
                  
                  {entrepreneurProjects.length > 0 ? (
                    entrepreneurProjects.map((project, index) => (
                      <Box key={index} sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, bgcolor: '#fafafa' }}>
                        <Typography variant="body1" sx={{ fontWeight: 600, mb: 1, color: '#333' }}>
                          {project.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                          Type: {project.project_type}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                          Industry: {project.industry_type}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Investment: {project.formatted_investment || `₹${project.investment_amount?.toLocaleString()}`}
                        </Typography>
                        <Chip 
                          label={project.status_display || project.status}
                          color={project.status === 'approved' ? 'success' : project.status === 'rejected' ? 'error' : 'warning'}
                          size="small"
                          sx={{ mt: 1 }}
                        />
                      </Box>
                    ))
                  ) : (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                      <Typography variant="body2" color="text.secondary">
                        No projects submitted
                      </Typography>
                    </Box>
                  )}
                </Box>

                {/* Column 3: Services */}
                <Box sx={{ width: '25%', p: 3, borderRight: '1px solid #e0e0e0', overflowY: 'auto' }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, textAlign: 'center', color: '#1976d2' }}>Services Requested</Typography>
                  
                  {entrepreneurProjects.map((project, projectIndex) => (
                    <Box key={projectIndex} sx={{ mb: 3 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#666' }}>
                        {project.name}
                      </Typography>
                      {project.services && Array.isArray(project.services) && project.services.length > 0 ? (
                        project.services.map((service, serviceIndex) => (
                          <Box key={serviceIndex} sx={{ mb: 1, p: 2, bgcolor: '#e3f2fd', borderRadius: 1, border: '1px solid #bbdefb' }}>
                            <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
                              {getServiceDisplayName(service)}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              ID: {generateServiceId(service, selectedEntrepreneur.id)}
                            </Typography>
                          </Box>
                        ))
                      ) : (
                        <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1, mb: 1 }}>
                          <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                            No services requested
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  ))}
                  
                  {entrepreneurProjects.length === 0 && (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                      <Typography variant="body2" color="text.secondary">
                        No projects to show services for
                      </Typography>
                    </Box>
                  )}
                </Box>

                {/* Column 4: Documents */}
                <Box sx={{ width: '25%', p: 3, overflowY: 'auto' }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, textAlign: 'center', color: '#1976d2' }}>Documents</Typography>
                  
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>User Documents</Typography>
                    
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography>📄</Typography>
                            <Typography variant="body2">Aadhar Document</Typography>
                          </Box>
                          <FormControl size="small" sx={{ minWidth: 120 }}>
                            <Select
                              value={entrepreneurProjects[0]?.aadhar_document_status || 'pending'}
                              onChange={(e) => handleUserDocumentStatusChange(selectedEntrepreneur.id, 'aadhar', e.target.value)}
                              displayEmpty
                              sx={{
                                '& .MuiSelect-select': {
                                  py: 0.5,
                                  fontSize: '0.75rem',
                                  color: entrepreneurProjects[0]?.aadhar_document_status === 'approved' ? '#2e7d32' : 
                                         entrepreneurProjects[0]?.aadhar_document_status === 'rejected' ? '#d32f2f' : 
                                         entrepreneurProjects[0]?.aadhar_document_status === 'pending' ? '#ed6c02' : '#666'
                                }
                              }}
                            >
                              <MenuItem value="pending">Pending</MenuItem>
                              <MenuItem value="under_review">Under Review</MenuItem>
                              <MenuItem value="approved">Approved</MenuItem>
                              <MenuItem value="rejected">Rejected</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                        {entrepreneurProjects[0]?.aadhar_document && (
                          <Button 
                            size="small" 
                            variant="outlined" 
                            onClick={() => {
                              const baseUrl = process.env.REACT_APP_API_URL?.replace('/api/v1', '') || 'http://localhost:8000';
                              const docUrl = entrepreneurProjects[0].aadhar_document.startsWith('http') 
                                ? entrepreneurProjects[0].aadhar_document 
                                : `${baseUrl}${entrepreneurProjects[0].aadhar_document}`;
                              setViewingDocument({ name: 'Aadhar Card', url: docUrl });
                              setDocumentViewerOpen(true);
                            }}
                            sx={{ fontSize: '0.75rem' }}
                          >
                            View Document
                          </Button>
                        )}
                      </Box>
                      
                      <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography>📄</Typography>
                            <Typography variant="body2">PAN Document</Typography>
                          </Box>
                          <FormControl size="small" sx={{ minWidth: 120 }}>
                            <Select
                              value={entrepreneurProjects[0]?.pan_document_status || 'pending'}
                              onChange={(e) => handleUserDocumentStatusChange(selectedEntrepreneur.id, 'pan', e.target.value)}
                              displayEmpty
                              sx={{
                                '& .MuiSelect-select': {
                                  py: 0.5,
                                  fontSize: '0.75rem',
                                  color: entrepreneurProjects[0]?.pan_document_status === 'approved' ? '#2e7d32' : 
                                         entrepreneurProjects[0]?.pan_document_status === 'rejected' ? '#d32f2f' : 
                                         entrepreneurProjects[0]?.pan_document_status === 'pending' ? '#ed6c02' : '#666'
                                }
                              }}
                            >
                              <MenuItem value="pending">Pending</MenuItem>
                              <MenuItem value="under_review">Under Review</MenuItem>
                              <MenuItem value="approved">Approved</MenuItem>
                              <MenuItem value="rejected">Rejected</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                        {entrepreneurProjects[0]?.pan_document && (
                          <Button 
                            size="small" 
                            variant="outlined" 
                            onClick={() => {
                              const baseUrl = process.env.REACT_APP_API_URL?.replace('/api/v1', '') || 'http://localhost:8000';
                              const docUrl = entrepreneurProjects[0].pan_document.startsWith('http') 
                                ? entrepreneurProjects[0].pan_document 
                                : `${baseUrl}${entrepreneurProjects[0].pan_document}`;
                              setViewingDocument({ name: 'PAN Card', url: docUrl });
                              setDocumentViewerOpen(true);
                            }}
                            sx={{ fontSize: '0.75rem' }}
                          >
                            View Document
                          </Button>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  
                  {entrepreneurProjects.length === 0 && (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                      <Typography variant="body2" color="text.secondary">
                        No documents uploaded yet
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Dialog>

      {/* Project Details Dialog */}
      <Dialog 
        open={openProjectDialog} 
        onClose={() => setOpenProjectDialog(false)} 
        maxWidth="xl" 
        fullWidth
        PaperProps={{
          sx: { minHeight: '90vh', maxHeight: '90vh' }
        }}
      >
        <Box sx={{ height: '90vh', display: 'flex', flexDirection: 'column' }}>
          {selectedProject && (
            <>
              {/* Header */}
              <Box sx={{ p: 3, borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
                    {selectedProject.name}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {selectedProject.project_type} • {selectedProject.industry_type}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Button variant="outlined" color="primary">Edit Project</Button>
                  <Button variant="outlined" color="error">Delete Project</Button>
                  <IconButton onClick={() => setOpenProjectDialog(false)}><Close /></IconButton>
                </Box>
              </Box>

              {/* 4-Column Layout */}
              <Box sx={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
                {/* Column 1: Project Information */}
                <Box sx={{ width: '25%', p: 3, borderRight: '1px solid #e0e0e0', overflowY: 'auto' }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, textAlign: 'center', color: '#1976d2' }}>Project Information</Typography>
                  
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Basic Details</Typography>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>Project Name</Typography>
                      <Typography variant="body2">{selectedProject.name}</Typography>
                    </Box>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>Project Type</Typography>
                      <Typography variant="body2">{selectedProject.project_type}</Typography>
                    </Box>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>Industry Type</Typography>
                      <Typography variant="body2">{selectedProject.industry_type}</Typography>
                    </Box>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>Investment Amount</Typography>
                      <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 600 }}>
                        {selectedProject.formatted_investment || `₹${selectedProject.investment_amount?.toLocaleString()}`}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Status</Typography>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                      <Chip 
                        label={selectedProject.status_display || selectedProject.status}
                        color={selectedProject.status === 'approved' ? 'success' : selectedProject.status === 'rejected' ? 'error' : 'warning'}
                        size="medium"
                      />
                    </Box>
                  </Box>

                  <Box>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Description</Typography>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                      <Typography variant="body2">
                        {selectedProject.description || 'No description provided'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Column 2: Entrepreneur Details */}
                <Box sx={{ width: '25%', p: 3, borderRight: '1px solid #e0e0e0', overflowY: 'auto' }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, textAlign: 'center', color: '#1976d2' }}>Entrepreneur Details</Typography>
                  
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Contact Information</Typography>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>Name</Typography>
                      <Typography variant="body2">{selectedProject.entrepreneur_name || 'Unknown'}</Typography>
                    </Box>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>Submission Date</Typography>
                      <Typography variant="body2">
                        {selectedProject.created_at ? new Date(selectedProject.created_at).toLocaleDateString() : 'N/A'}
                      </Typography>
                    </Box>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>Last Updated</Typography>
                      <Typography variant="body2">
                        {selectedProject.updated_at ? new Date(selectedProject.updated_at).toLocaleDateString() : 'N/A'}
                      </Typography>
                    </Box>
                  </Box>

                  <Box>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Assigned Consultant</Typography>
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                      {selectedProject.consultant_name ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Avatar sx={{ width: 32, height: 32, bgcolor: '#1976d2' }}>
                            {selectedProject.consultant_name.charAt(0)}
                          </Avatar>
                          <Box>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              {selectedProject.consultant_name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {selectedProject.consultant_designation || 'Consultant'}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                          No consultant assigned
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>

                {/* Column 3: Services Requested */}
                <Box sx={{ width: '25%', p: 3, borderRight: '1px solid #e0e0e0', overflowY: 'auto' }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, textAlign: 'center', color: '#1976d2' }}>Services Requested</Typography>
                  
                  {selectedProject.services && Array.isArray(selectedProject.services) && selectedProject.services.length > 0 ? (
                    selectedProject.services.map((service, index) => (
                      <Box key={index} sx={{ mb: 2, p: 2, bgcolor: '#e3f2fd', borderRadius: 1, border: '1px solid #bbdefb' }}>
                        <Typography variant="body1" sx={{ fontWeight: 600, mb: 1, color: '#1565c0' }}>
                          {getServiceDisplayName(service)}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                          Service ID: {generateServiceId(service, selectedProject.entrepreneur)}
                        </Typography>
                        <Chip 
                          label="Requested"
                          color="primary"
                          size="small"
                          variant="outlined"
                        />
                      </Box>
                    ))
                  ) : (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                        No services requested for this project
                      </Typography>
                    </Box>
                  )}
                </Box>

                {/* Column 4: Documents & Progress */}
                <Box sx={{ width: '25%', p: 3, overflowY: 'auto' }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, textAlign: 'center', color: '#1976d2' }}>Documents & Progress</Typography>
                  
                  <Box sx={{ mb: 4 }}>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Submitted Documents</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography>📄</Typography>
                            <Typography variant="body2">Aadhar Document</Typography>
                          </Box>
                          <FormControl size="small" sx={{ minWidth: 120 }}>
                            <Select
                              value={selectedProject.aadhar_document_status || 'under_review'}
                              onChange={(e) => handleDocumentStatusChange(selectedProject.id, 'aadhar', e.target.value)}
                              displayEmpty
                              sx={{
                                '& .MuiSelect-select': {
                                  py: 0.5,
                                  fontSize: '0.75rem',
                                  color: selectedProject.aadhar_document_status === 'approved' ? '#2e7d32' : 
                                         selectedProject.aadhar_document_status === 'rejected' ? '#d32f2f' : 
                                         selectedProject.aadhar_document_status === 'pending' ? '#ed6c02' : '#666'
                                }
                              }}
                            >
                              <MenuItem value="under_review">Under Review</MenuItem>
                              <MenuItem value="approved">Approved</MenuItem>
                              <MenuItem value="rejected">Rejected</MenuItem>
                              <MenuItem value="pending">Pending</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Box>
                      
                      <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography>📄</Typography>
                            <Typography variant="body2">PAN Document</Typography>
                          </Box>
                          <FormControl size="small" sx={{ minWidth: 120 }}>
                            <Select
                              value={selectedProject.pan_document_status || 'under_review'}
                              onChange={(e) => handleDocumentStatusChange(selectedProject.id, 'pan', e.target.value)}
                              displayEmpty
                              sx={{
                                '& .MuiSelect-select': {
                                  py: 0.5,
                                  fontSize: '0.75rem',
                                  color: selectedProject.pan_document_status === 'approved' ? '#2e7d32' : 
                                         selectedProject.pan_document_status === 'rejected' ? '#d32f2f' : 
                                         selectedProject.pan_document_status === 'pending' ? '#ed6c02' : '#666'
                                }
                              }}
                            >
                              <MenuItem value="under_review">Under Review</MenuItem>
                              <MenuItem value="approved">Approved</MenuItem>
                              <MenuItem value="rejected">Rejected</MenuItem>
                              <MenuItem value="pending">Pending</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Box>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>DPR Progress</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      {[
                        { step: 'Project Submission', completed: true },
                        { step: 'Document Verification', completed: selectedProject.documents_fully_approved },
                        { step: 'Technical Review', completed: selectedProject.status !== 'submitted' },
                        { step: 'Financial Analysis', completed: selectedProject.status === 'approved' || selectedProject.status === 'commissioned' },
                        { step: 'Final Approval', completed: selectedProject.status === 'approved' || selectedProject.status === 'commissioned' }
                      ].map((item, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 1 }}>
                          <Box 
                            sx={{ 
                              width: 12, 
                              height: 12, 
                              borderRadius: '50%', 
                              bgcolor: item.completed ? '#4caf50' : '#e0e0e0' 
                            }} 
                          />
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              color: item.completed ? '#333' : '#999',
                              fontWeight: item.completed ? 500 : 400
                            }}
                          >
                            {item.step}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Dialog>

      {/* Admin Profile Edit Dialog */}
      <Dialog open={openAdminProfileDialog} onClose={() => setOpenAdminProfileDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>Edit Admin Profile</Typography>
          <IconButton onClick={() => setOpenAdminProfileDialog(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, mt: 2 }}>
            <TextField
              fullWidth
              label="Username"
              value={adminProfileData.username}
              onChange={(e) => setAdminProfileData({ ...adminProfileData, username: e.target.value })}
              size="small"
            />
            
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={adminProfileData.email}
              onChange={(e) => setAdminProfileData({ ...adminProfileData, email: e.target.value })}
              size="small"
            />
            
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                fullWidth
                label="First Name"
                value={adminProfileData.first_name}
                onChange={(e) => setAdminProfileData({ ...adminProfileData, first_name: e.target.value })}
                size="small"
              />
              
              <TextField
                fullWidth
                label="Last Name"
                value={adminProfileData.last_name}
                onChange={(e) => setAdminProfileData({ ...adminProfileData, last_name: e.target.value })}
                size="small"
              />
            </Box>
            
            <TextField
              fullWidth
              label="Phone"
              value={adminProfileData.phone}
              onChange={(e) => setAdminProfileData({ ...adminProfileData, phone: e.target.value })}
              size="small"
            />
            
            <Typography variant="subtitle2" sx={{ mt: 2, fontWeight: 600, color: '#666' }}>
              Change Password (Optional)
            </Typography>
            
            <TextField
              fullWidth
              label="Current Password"
              type="password"
              value={adminProfileData.current_password}
              onChange={(e) => setAdminProfileData({ ...adminProfileData, current_password: e.target.value })}
              size="small"
              helperText="Required to change password"
            />
            
            <TextField
              fullWidth
              label="New Password"
              type="password"
              value={adminProfileData.new_password}
              onChange={(e) => setAdminProfileData({ ...adminProfileData, new_password: e.target.value })}
              size="small"
            />
            
            <TextField
              fullWidth
              label="Confirm New Password"
              type="password"
              value={adminProfileData.confirm_password}
              onChange={(e) => setAdminProfileData({ ...adminProfileData, confirm_password: e.target.value })}
              size="small"
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={() => setOpenAdminProfileDialog(false)}>Cancel</Button>
          <Button 
            variant="contained" 
            onClick={async () => {
              try {
                // Validate password change if attempted
                if (adminProfileData.new_password) {
                  if (!adminProfileData.current_password) {
                    alert('Please enter your current password to change it');
                    return;
                  }
                  if (adminProfileData.new_password !== adminProfileData.confirm_password) {
                    alert('New passwords do not match');
                    return;
                  }
                  if (adminProfileData.new_password.length < 6) {
                    alert('New password must be at least 6 characters');
                    return;
                  }
                }

                const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
                const updateData = {
                  username: adminProfileData.username,
                  email: adminProfileData.email,
                  first_name: adminProfileData.first_name,
                  last_name: adminProfileData.last_name,
                  phone: adminProfileData.phone
                };

                // Add password fields if changing password
                if (adminProfileData.new_password) {
                  updateData.current_password = adminProfileData.current_password;
                  updateData.password = adminProfileData.new_password;
                }

                await apiService.updateStaff(userInfo.id, updateData);
                
                // Update local storage
                const updatedUserInfo = { ...userInfo, ...updateData };
                delete updatedUserInfo.current_password;
                delete updatedUserInfo.password;
                localStorage.setItem('userInfo', JSON.stringify(updatedUserInfo));
                
                alert('Profile updated successfully!');
                setOpenAdminProfileDialog(false);
              } catch (error) {
                console.error('Error updating profile:', error);
                alert('Failed to update profile. Please check your current password and try again.');
              }
            }}
            sx={{ bgcolor: '#1976d2' }}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Document Viewer Dialog */}
      <Dialog
        open={documentViewerOpen}
        onClose={() => {
          setDocumentViewerOpen(false);
          setViewingDocument(null);
        }}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            height: '90vh',
            maxHeight: '90vh'
          }
        }}
      >
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          p: 2,
          borderBottom: '1px solid #e0e0e0',
          bgcolor: 'white'
        }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {viewingDocument?.name || 'Document Preview'}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Button
              variant="contained"
              onClick={() => {
                // Force download using fetch and blob
                fetch(viewingDocument?.url)
                  .then(response => response.blob())
                  .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = viewingDocument?.name || 'document';
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                  })
                  .catch(error => {
                    console.error('Download failed:', error);
                    // Fallback: open in new tab
                    window.open(viewingDocument?.url, '_blank');
                  });
              }}
              sx={{ 
                bgcolor: '#1976d2',
                '&:hover': { bgcolor: '#1565c0' },
                textTransform: 'none'
              }}
            >
              Download
            </Button>
            <IconButton 
              onClick={() => {
                setDocumentViewerOpen(false);
                setViewingDocument(null);
              }}
              sx={{ color: '#666' }}
            >
              <Close />
            </IconButton>
          </Box>
        </Box>
        <DialogContent sx={{ p: 0, height: '100%', overflow: 'hidden', bgcolor: '#f5f5f5' }}>
          {viewingDocument && (
            <Box sx={{ width: '100%', height: '100%' }}>
              {viewingDocument.url.toLowerCase().endsWith('.pdf') ? (
                <embed
                  src={`${viewingDocument.url}#toolbar=0&navpanes=0&scrollbar=0`}
                  type="application/pdf"
                  style={{
                    width: '100%',
                    height: '100%',
                    border: 'none'
                  }}
                  title={viewingDocument.name}
                />
              ) : (
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 2
                  }}
                >
                  <img
                    src={viewingDocument.url}
                    alt={viewingDocument.name}
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                    }}
                  />
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default AdminDashboard;